import { Component, OnInit } from '@angular/core';
import {RoomDef} from "../../../model/server";
import {ActivatedRoute, ParamMap} from "@angular/router";
import {forkJoin} from "rxjs";
import {switchMap, take, tap} from "rxjs/operators";
import {TeacherVideoRestService} from "../../../services/rest/teacher-video-rest.service";

@Component({
    selector: 'app-teacher-room-details-page',
    templateUrl: './teacher-room-details-page.component.html',
    styleUrls: ['./teacher-room-details-page.component.scss'],
    standalone: false
})
export class TeacherRoomDetailsPageComponent implements OnInit {

  schoolId: number;
  teacherId: number;
  roomUuid: string;
  roomData: RoomDef;

  constructor(
    activatedRoute: ActivatedRoute,
    private rest: TeacherVideoRestService
  ) {

    forkJoin([
      activatedRoute.paramMap.pipe(take(1)),
      activatedRoute.parent.paramMap.pipe(take(1))
    ]).pipe(
      tap<[ParamMap, ParamMap]>( ([params, parentParams]) => this.readParams(params, parentParams)),
      switchMap( _ => this.loadRoomData())
    ).subscribe();
  }

  private loadRoomData() {
    return this.rest.getRoomDetails(this.schoolId, this.teacherId, this.roomUuid).pipe(
      tap( roomData => this.storeRoomData(roomData))
    )
  }

  private storeRoomData(roomData: RoomDef) {
    this.roomData = roomData;
  }

  private readParams(params: ParamMap, parentParams: ParamMap) {
    console.log(params);
    this.schoolId = Number(parentParams.get('schoolId'));
    this.teacherId = Number(parentParams.get('teacherId'));
    this.roomUuid = params.get('roomUuid');
  }

  ngOnInit(): void {
  }


}
